export default __webpack_public_path__ + "static/media/quadro-kevlar.c833a021.png";